function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 12.305c.902-.622 1.535-1.644 1.535-2.59 0-2.1-1.628-3.715-3.721-3.715H12v13h6.549C20.493 19 22 17.421 22 15.48c0-1.41-.8-2.618-2-3.175zm-5.209-3.984h2.79c.773 0 1.396.623 1.396 1.393 0 .771-.623 1.393-1.395 1.393h-2.79V8.321zm0 8.358h3.256c.772 0 1.395-.623 1.395-1.393 0-.771-.623-1.393-1.395-1.393H14.79v2.786z",
  clipRule: "evenodd"
});

var SvgStyleBold = function SvgStyleBold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStyleBold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/style_bold.f280a850.svg";
export { ForwardRef as ReactComponent };